/**
 * Defined in:
 *   {@link file://./../../../dxos/client/services.proto}
 */
export var SystemStatus;
(function (SystemStatus) {
    SystemStatus[SystemStatus["ACTIVE"] = 0] = "ACTIVE";
    SystemStatus[SystemStatus["INACTIVE"] = 1] = "INACTIVE";
})(SystemStatus || (SystemStatus = {}));
/**
 * Defined in:
 *   {@link file://./../../../dxos/client/services.proto}
 */
export var DeviceKind;
(function (DeviceKind) {
    DeviceKind[DeviceKind["CURRENT"] = 0] = "CURRENT";
    DeviceKind[DeviceKind["TRUSTED"] = 1] = "TRUSTED";
})(DeviceKind || (DeviceKind = {}));
export var SpaceMember;
(function (SpaceMember) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let PresenceState;
    (function (PresenceState) {
        PresenceState[PresenceState["OFFLINE"] = 0] = "OFFLINE";
        PresenceState[PresenceState["ONLINE"] = 1] = "ONLINE";
    })(PresenceState = SpaceMember.PresenceState || (SpaceMember.PresenceState = {}));
})(SpaceMember || (SpaceMember = {}));
/**
 * Runtime state of the space object.
 *
 * Defined in:
 *   {@link file://./../../../dxos/client/services.proto}
 */
export var SpaceState;
(function (SpaceState) {
    SpaceState[SpaceState["CLOSED"] = 1] = "CLOSED";
    SpaceState[SpaceState["INACTIVE"] = 2] = "INACTIVE";
    SpaceState[SpaceState["INITIALIZING"] = 4] = "INITIALIZING";
    SpaceState[SpaceState["READY"] = 3] = "READY";
})(SpaceState || (SpaceState = {}));
export var Invitation;
(function (Invitation) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let Type;
    (function (Type) {
        Type[Type["INTERACTIVE"] = 0] = "INTERACTIVE";
        Type[Type["OFFLINE"] = 1] = "OFFLINE";
        Type[Type["MULTIUSE"] = 2] = "MULTIUSE";
    })(Type = Invitation.Type || (Invitation.Type = {}));
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let Kind;
    (function (Kind) {
        Kind[Kind["DEVICE"] = 0] = "DEVICE";
        Kind[Kind["SPACE"] = 1] = "SPACE";
    })(Kind = Invitation.Kind || (Invitation.Kind = {}));
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let AuthMethod;
    (function (AuthMethod) {
        AuthMethod[AuthMethod["NONE"] = 0] = "NONE";
        AuthMethod[AuthMethod["SHARED_SECRET"] = 1] = "SHARED_SECRET";
    })(AuthMethod = Invitation.AuthMethod || (Invitation.AuthMethod = {}));
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let State;
    (function (State) {
        State[State["INIT"] = 0] = "INIT";
        State[State["CONNECTING"] = 1] = "CONNECTING";
        State[State["CONNECTED"] = 2] = "CONNECTED";
        State[State["READY_FOR_AUTHENTICATION"] = 3] = "READY_FOR_AUTHENTICATION";
        State[State["AUTHENTICATING"] = 4] = "AUTHENTICATING";
        State[State["SUCCESS"] = 5] = "SUCCESS";
        State[State["CANCELLED"] = 6] = "CANCELLED";
        State[State["TIMEOUT"] = 7] = "TIMEOUT";
        State[State["ERROR"] = 8] = "ERROR";
    })(State = Invitation.State || (Invitation.State = {}));
})(Invitation || (Invitation = {}));
/**
 * Defined in:
 *   {@link file://./../../../dxos/client/services.proto}
 */
export var ConnectionState;
(function (ConnectionState) {
    ConnectionState[ConnectionState["OFFLINE"] = 0] = "OFFLINE";
    ConnectionState[ConnectionState["ONLINE"] = 1] = "ONLINE";
})(ConnectionState || (ConnectionState = {}));
//# sourceMappingURL=services.js.map